'use client';

import { useEffect, useRef } from 'react';
import { renderRawHtml } from './render-raw-html';
import { RawHtmlEmbedProps } from './types';

// EWM-530 — renders editor-authored HTML/CSS/JS verbatim. The content is
// injected client-side via a ref (not dangerouslySetInnerHTML) because the
// HTML parser produces inert <script> tags; renderRawHtml upgrades them to
// live script elements so the browser executes them. The effect re-runs when
// `code` changes, re-injecting (and clearing the previous content first).
const RawHtmlEmbed = ({ code }: RawHtmlEmbedProps) => {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hostRef.current) {
      renderRawHtml(hostRef.current, code ?? '');
    }
  }, [code]);

  return <div ref={hostRef} data-testid="raw-html-embed" />;
};

export default RawHtmlEmbed;
